import React from 'react'

import PersonCoverageModal from 'components/PersonCoverageModal'

const DENTAL_COVERAGE_DESCRIPTION =
  'We’ll calculate your dental plan pricing based on who you want to cover. Use the checkboxes and click “Save” to make any changes.'

const DentalCoverageModal = (props) => (
  <PersonCoverageModal description={DENTAL_COVERAGE_DESCRIPTION} {...props} />
)

DentalCoverageModal.displayName = 'DentalCoverageModal'

export default DentalCoverageModal
